module.exports = __webpack_public_path__ + "static/deal-mart-70b64e35553244e0499f22f768acb99a.png";